<template>
    <span v-if="locationType">
        <template v-if="locationType === MeetingLocationTypeEnum.GoogleMeet">
            <a
                @click.stop
                :href="locationData.meetingUri"
                target="_blank"
                class="text-blue-500 hover:underline"
            >
                Google Meet
            </a>
        </template>

        <template v-if="locationType === MeetingLocationTypeEnum.Phone">
            <a
                @click.stop
                :href="`tel:${locationData.phoneNumberE164Format}`"
                target="_blank"
                class="text-blue-500 hover:underline"
            >
                {{ locationData.phoneNumberInternationalFormat }}
            </a>
        </template>

        <template v-if="locationType === MeetingLocationTypeEnum.Zoom">
            <a
                @click.stop
                :href="locationData.joinUrl"
                target="_blank"
                class="text-blue-500 hover:underline"
            >
                Zoom
            </a>
        </template>

        <template
            v-if="
                [
                    MeetingLocationTypeEnum.InPersonHostDefined,
                    MeetingLocationTypeEnum.InPersonAttendeeDefined,
                ].includes(locationType)
            "
        >
            <a
                v-if="locationData.googleMapsUrl"
                @click.stop
                :href="locationData.googleMapsUrl"
                target="_blank"
                class="text-blue-500 hover:underline"
            >
                {{ locationData.address }}
            </a>
            <span v-else>
                {{ locationData.address }}
            </span>
        </template>
    </span>
    <span
        v-else
        class="text-gray-400 italic"
    >
        Pending...
    </span>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import { MeetingLocationTypeEnum } from '@/Shared/AutoGenerated/Main'

    const props = defineProps({
        locationType: {
            type: String as PropType<MeetingLocationTypeEnum | null>,
            required: true,
        },
        locationData: {
            type: Object as PropType<any>,
            required: true,
        },
    })
</script>
